import { bl_fi_einvoice_printable_email_content_RowClass } from '../../dbschema/bl_fi_einvoice_printable_email_content.model';
import { BaseContainerModel } from '../base-container.model';

export class EinvoicePrintableEmailContentContainerModel extends BaseContainerModel {
    bl_fi_einvoice_printable_email_content: bl_fi_einvoice_printable_email_content_RowClass = new bl_fi_einvoice_printable_email_content_RowClass();
}